import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener('input', this.formatPhone.bind(this))
    this.element.addEventListener('keydown', this.handleKeyDown.bind(this))
    this.element.addEventListener('keydown', this.handleBackspace.bind(this))
  }

  handleBackspace(e) {
    // Обработка backspace и delete
    if (e.keyCode === 8 || e.keyCode === 46) {
      const cursorPos = e.target.selectionStart
      const value = e.target.value
      
      // Если курсор после символа форматирования (скобка, пробел, тире)
      // пропустить его и удалить цифру перед ним
      if (e.keyCode === 8 && cursorPos > 0) { // backspace
        const charBefore = value[cursorPos - 1]
        if (charBefore && /[\s\-\(\)]/.test(charBefore)) {
          e.preventDefault()
          
          // Найти позицию предыдущей цифры
          let newPos = cursorPos - 1
          while (newPos > 0 && /[^0-9]/.test(value[newPos - 1])) {
            newPos--
          }
          
          if (newPos > 0) {
            // Удалить цифру и переформатировать
            const digits = value.replace(/\D/g, '')
            const newDigits = digits.slice(0, digits.length - 1)
            
            this.setFormattedValue(e.target, newDigits)
          }
        }
      }
    }
  }

  setFormattedValue(element, digits) {
    let formattedValue = ''
    
    if (digits.length === 0) {
      element.value = ''
      return
    }
    
    if (digits.length > 0) {
      formattedValue = '+7'
      if (digits.length > 1) {
        formattedValue += ' (' + digits.substring(1, 4)
      }
      if (digits.length >= 4) {
        formattedValue += ') ' + digits.substring(4, 7)
      }
      if (digits.length >= 7) {
        formattedValue += '-' + digits.substring(7, 9)
      }
      if (digits.length >= 9) {
        formattedValue += '-' + digits.substring(9, 11)
      }
    }
    
    element.value = formattedValue
    
    // Установить курсор в конец
    element.setSelectionRange(formattedValue.length, formattedValue.length)
  }

  formatPhone(e) {
    let value = e.target.value.replace(/\D/g, '')
    
    // Limit to 11 digits (Russian phone number)
    if (value.length > 11) {
      value = value.slice(0, 11)
    }

    let formattedValue = ''
    
    // Если нет цифр вообще, оставить поле пустым
    if (value.length === 0) {
      e.target.value = ''
      return
    }
    
    // Если есть хоть одна цифра, начинать с +7
    if (value.length > 0) {
      formattedValue = '+7'
      if (value.length > 1) {
        formattedValue += ' (' + value.substring(1, 4)
      }
      if (value.length >= 4) {
        formattedValue += ') ' + value.substring(4, 7)
      }
      if (value.length >= 7) {
        formattedValue += '-' + value.substring(7, 9)
      }
      if (value.length >= 9) {
        formattedValue += '-' + value.substring(9, 11)
      }
    }

    e.target.value = formattedValue
  }

  handleKeyDown(e) {
    // Allow: backspace, delete, tab, escape, enter
    if ([46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (e.keyCode === 65 && e.ctrlKey === true) ||
        (e.keyCode === 67 && e.ctrlKey === true) ||
        (e.keyCode === 86 && e.ctrlKey === true) ||
        (e.keyCode === 88 && e.ctrlKey === true) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
      return
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault()
    }
  }
}
